// extracted by mini-css-extract-plugin
module.exports = {"toastsWrapper":"YF7Vb0zK","toast":"_MBVp3HS"};